import { render, staticRenderFns } from "./chatMain.vue?vue&type=template&id=802b0864&scoped=true&"
import script from "./chatMain.vue?vue&type=script&lang=js&"
export * from "./chatMain.vue?vue&type=script&lang=js&"
import style0 from "./chatMain.vue?vue&type=style&index=0&id=802b0864&prod&scoped=true&lang=scss&"
import style1 from "./chatMain.vue?vue&type=style&index=1&id=802b0864&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802b0864",
  null
  
)

export default component.exports